<div id="main-content" class="home-content">
    <h1>Renzo Barduagni</h1>
    <p>
        Senior Software Engineer. Extensive experience as an application developer in all phases of software development including Requirements, Analysis, Specifications, Design, Development, Conversions, Installations, Maintenance, etc. within the financial, service, manufacturing, transportation and distribution/warehousing areas. Successful deployment of complex applications across multiple database platforms. Extensive experience in creating, maintaining and tuning Views, Stored Procedures, Functions and Triggers using SQL and T-SQL. Over fifteen years experience in building internet/intranet application and web services.
    </p>
    <p>
        Over twenty years experience in developing database applications initially in C, C++ and Paradox then with extensive use of Delphi, Visual Studio and higher-level databases such as MS SQL Server and Interbase.
    </p>
    <p>
        Exceptional understanding and extensive use of OO design and development.
    </p>
    <p>
        Excellent problem solving and communication skills with the ability to work under pressure in highly visible role.
    </p>
</div>

